<script>
    import ResultStatistics from "./ResultStatistics.svelte";
    export let result;
</script>

<h1><b>{result.job}</b> ({(result.score * 100).toFixed(0)}% Übereinstimmung)</h1>

{#if result.job_type == "STUDIUM"}
    {#if Object.entries(result.steckbrief).length > 0}
        <h2>{Object.keys(result.steckbrief)[0]}</h2>
        <p>{Object.values(result.steckbrief)[0].join('\n')}</p>

        {#if result.schwerpunkte && result.schwerpunkte.length > 0}
            <h2>Schwerpunkte</h2>
            <p>Bei diesem Studiengang könnten dich die folgenden Schwerpunktsetzungen bzw. Spezialisierungen interessieren:</p>
            <ul>
                {#each result.schwerpunkte as schwerpunkt}
                    <li>{schwerpunkt['job']}</li>
                {/each}
            </ul>
        {/if}

        <h2>Inhalte des Studiums</h2>
        <ul>
            {#each result.steckbrief["Inhalte des Studiums"] as inhalt}
                <li>{inhalt}</li>
            {/each}
        </ul>
        <p></p>

        <h2>Alternativbezeichnungen</h2>
        <p>Zu diesem Studiengang gibt es unter anderem die folgenden Alternativstudiengänge/Alternativbezeichnungen:</p>
        <ul>
            {#if result.alternative_job_title != ""}
                <li>{result.alternative_job_title}</li>
            {/if}
            {#each result.steckbrief["studiengangsbezeichnungen"] as alternative}
                <li>{alternative}</li>
            {/each}
        </ul>

        <h2>Nach dem Studium</h2>
        <p>{result.steckbrief["Nach dem Studium"].join('\n')}</p>

        <h2>Weiterführende Studiengänge</h2>
        <p>{result.steckbrief["weiterfuehrende_studienfaecher"]["text"]}</p>
        <ul>
            {#each result.steckbrief["weiterfuehrende_studienfaecher"]["list"] as inhalt}
                <li>{inhalt}</li>
            {/each}
        </ul>       

        <p>Diese Informationen stammen von <a class="text-accent-dark hover:text-accent-highlight" target="_blank" rel="noopener noreferrer" href="https://web.arbeitsagentur.de/berufenet/beruf/{result.id}">Berufenet (Link zum Studium)</a>. Dort findest du noch mehr Details zu dem Studiengang!</p>
    {:else}
        <p>Informationen zu diesem Studiengang findest du beispielsweise bei <a class="text-accent-dark hover:text-accent-highlight" target="_blank" rel="noopener noreferrer" href="https://web.arbeitsagentur.de/berufenet/beruf/{result.id}">Berufenet (Link zum Studium)</a>.</p>
    {/if}
{/if}
{#if result.job_type == "AUSBILDUNG"}
    {#if Object.entries(result.steckbrief).length > 0}
        <h2>Was macht man in diesem Beruf?</h2>
        <p>{result.steckbrief["Was macht man in diesem Beruf?"].join('\n')}</p>
        {#if result.alternative_job_title != ""}
            <p>In dem Gebiet gibt es auch die folgende(n) ähnliche Ausbildung(en): {result.alternative_job_title}</p>
        {/if}


        {#if result.steckbrief['ausbildungsinhalt'] != {}}
            <h2>Was macht man während der Ausbildung?</h2>
            <p>Während der theoretischen und praktischen Ausbildung erwirbt man beispielsweise folgende Kenntnisse: </p>
            <ul>
                {#each Object.values(result.steckbrief['ausbildungsinhalt'])[0] as inhalt}
                    <li>{inhalt}</li>
                {/each}
            </ul>
        {/if}

        <h2>Wo arbeitet man?</h2>
        <ul>
            {#each result.steckbrief["Wo arbeitet man?"] as inhalt}
                <li>{inhalt}</li>
            {/each}
        </ul>

        {#if result.schwerpunkte && result.schwerpunkte.length > 0}
            <h2>Schwerpunkte</h2>
            <p>Bei dieser Ausbildung könnten dich die folgenden Schwerpunktsetzungen bzw. Spezialisierungen interessieren:</p>
            <ul>
                {#each result.schwerpunkte as schwerpunkt}
                    <li>{schwerpunkt['job']}</li>
                {/each}
            </ul>
        {/if}

        <h2>Welche Anpassungsmöglichkeiten gibt es?</h2>
        <ul>
            {#each Object.values(result.steckbrief['anpassung']) as inhalt}
                <li>{inhalt}</li>
            {/each}
        </ul>
        
        <h2>Welche Aufstiegs- und Weiterbildungsmöglichkeiten gibt es?</h2>
        <ul>
            {#each Object.values(result.steckbrief['aufstieg']) as inhalt}
                <li>{inhalt}</li>
            {/each}
        </ul>


        <p>Diese Informationen stammen von <a class="text-accent-dark hover:text-accent-highlight" target="_blank" rel="noopener noreferrer" href="https://web.arbeitsagentur.de/berufenet/beruf/{result.id}">Berufenet (Link zur Ausbildung)</a>. Dort findest du noch mehr Details zu der Ausbildung!</p>
    {:else}
        <p>Informationen zu dieser Ausbildung findest du beispielsweise bei <a class="text-accent-dark hover:text-accent-highlight" target="_blank" rel="noopener noreferrer" href="https://web.arbeitsagentur.de/berufenet/beruf/{result.id}">Berufenet (Link zur Ausbildung)</a>.</p>
    {/if}
{/if}

{#if result}
    <h2>Übereinstimmung pro Kategorie</h2>
    <ResultStatistics category_scores={Object.keys(result.category_scores)
        .filter(key => ["Interessen", "Fähigkeiten", "Schulfächer"].includes(key))
        .reduce((obj, key) => {
          obj[key] = result.category_scores[key];
          return obj;
        }, {})}/>
{/if}

